import React from 'react';
import { getSkinUrl } from '../api';

export default function PlayerCard({ rank, username, blocks, onClick }) {
  const formatNumber = (n) => n?.toLocaleString('es-DO') || '0';

  const medalEmoji = rank === 1 ? '🥇' : rank === 2 ? '🥈' : rank === 3 ? '🥉' : null;

  return (
    <div
      onClick={onClick}
      className={`mc-border rounded-xl p-4 bg-mc-card hover:mc-glow cursor-pointer transition-all hover:scale-[1.02] hover:border-mc-accent/50 ${
        rank <= 3 ? 'border-mc-gold/40' : ''
      }`}
    >
      <div className="flex items-center gap-4">
        <div className="relative">
          <img
            src={getSkinUrl(username)}
            alt={username}
            className="w-12 h-12 rounded-lg image-rendering-pixelated"
            style={{ imageRendering: 'pixelated' }}
          />
          {medalEmoji && (
            <span className="absolute -top-2 -right-2 text-lg">{medalEmoji}</span>
          )}
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span className="text-mc-muted text-xs font-mono">#{rank}</span>
            <span className="text-mc-text font-semibold truncate">{username}</span>
          </div>
          <div className="flex items-center gap-1 mt-1">
            <span className="text-mc-accent font-bold">{formatNumber(blocks)}</span>
            <span className="text-mc-muted text-xs">bloques</span>
          </div>
        </div>

        <div className="text-mc-muted text-xl">›</div>
      </div>
    </div>
  );
}
